export enum POTab {
  draft = "Draft Purchase Orders",
  open = "Open Purchase Orders",
  closed = "Closed Purchase Orders",
  archived = "Archived Purchase Orders",
}

// Broader "draft-like" set used by UI listings/tabs (e.g. the Drafts tab and its count).
// Includes `pre_draft` — POs not yet promoted to a real draft but still surfaced under Drafts.
// For the narrower set used by counts/summaries that should exclude transitional pre-drafts,
// see `COMMITTED_DRAFT_STATUSES` / `isCommittedDraftStatus` in `~/utils/purchaseOrders`.
export const draftTabPOStatuses = ["pre_draft", "draft", "draft_approved"]
export const openPOStatuses = ["sent"]
export const closedPOStatuses = ["registered", "delivered"]
